import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <h1>
              <a href="/" className="flex items-center gap-3 cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/1c25e8811aca7c6ca186f30e4b2227d5/8afac7b945d8ebdb82ad7b0d561e6124.png" 
                  alt="Feenex" 
                  className="h-10 w-auto transition-all duration-300"
                  style={isScrolled ? {
                    filter: 'brightness(0) saturate(100%) invert(13%) sepia(47%) saturate(800%) hue-rotate(170deg) brightness(90%) contrast(110%)'
                  } : {}}
                />
              </a>
            </h1>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#solucoes" className={`text-sm font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-feenex-blue hover:text-feenex-gold' : 'text-white hover:text-feenex-gold'
            }`}>
              Soluções
            </a>
            <a href="#como-funciona" className={`text-sm font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-feenex-blue hover:text-feenex-gold' : 'text-white hover:text-feenex-gold'
            }`}>
              Como Funciona
            </a>
            <a href="#diferenciais" className={`text-sm font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-feenex-blue hover:text-feenex-gold' : 'text-white hover:text-feenex-gold'
            }`}>
              Diferenciais
            </a>
            <a href="#faq" className={`text-sm font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-feenex-blue hover:text-feenex-gold' : 'text-white hover:text-feenex-gold'
            }`}>
              FAQ
            </a>
            <a href="#contato" className={`px-6 py-2.5 rounded-md font-medium transition-all cursor-pointer whitespace-nowrap ${
              isScrolled 
                ? 'bg-feenex-blue text-white hover:bg-feenex-gold hover:text-feenex-blue' 
                : 'bg-feenex-gold text-feenex-blue hover:bg-white'
            }`}>
              Falar com Especialista
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}